import $ from 'jquery';
import debounce from 'lodash/debounce';
import { breakpoints } from "../utils";

export default class {
  constructor(el) {
    const self = this;
    self.$el = $(el);
    self.$links = self.$el.find(".js-quicklink");
    self.$breakpoints = $(".js-breakpoint");
    self.state = null;
    self.resize = debounce(self.resize.bind(self), 250);

    // $(window).on('resize', self.resize).trigger('resize');

    self.$links.on("click", function(event){
      const href = $(this).attr('href');
      if(href !== "#contact"){
        history.pushState(null, null, href);
        self.$links.removeClass('is-active');
        self.$links.filter(`[href="${href}"]`).addClass('is-active');
        self.isAnimating = true;
        $('html, body').stop().animate({
            scrollTop: $(href).offset().top,
        }, 850, function(){
          self.isAnimating = false;
        });
        event.preventDefault();
      }
    });

    // $(window).on('scroll', function() {
    //   if(self.state === "desktop") {
    //     const scrollTop = $(window).scrollTop();
    //     const scrollBottom = scrollTop + $(window).height();

    //     if(scrollTop > self.scrollTop){
    //       $("body").addClass('has-fixed-quicklinks');
    //     } else {
    //       $("body").removeClass('has-fixed-quicklinks');
    //     }

    //     if(!self.isAnimating){
    //       let read = [];
    //       self.$breakpoints.each(function(index, breakpoint) {
    //         const $breakpoint = $(breakpoint);
    //         const breakpointTop = $breakpoint.offset().top;
    //         if(breakpointTop < scrollBottom) {
    //           read.push($breakpoint.attr("id"));
    //         }
    //       });

    //       if(read.length){
    //         self.$links.removeClass('is-active');
    //         self.$links.filter(`[href="#${read[read.length-1]}"]`).addClass('is-active');
    //       }
    //     }
    //   }
    // });
  }
  resize() {
    const self = this;
    if($(window).width() < breakpoints.tablet && self.state !== "mobile") {
      self.state = "mobile";
    } else if($(window).width() >= breakpoints.tablet && self.state !== "desktop") {
      self.state = "desktop";
      self.scrollTop = self.$el.offset().top;
    }
    // $(window).trigger("scroll");
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Quicklinks.js